// client/src/components/landing/AdAgencySection.js
// 광고 대행 문의 섹션 — v6 B안 리디자인 (다크 카드). /contact 이동은 기존 그대로.
import React from 'react';
import { useNavigate } from 'react-router-dom';

function AdAgencySection() {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <section className="lnd-sec lnd-wrap" style={{ paddingTop: 8 }}>
      <div className="agency">
        <h2>직접 운영이 어렵다면, 대행으로</h2>
        <p>바이럴 캠페인 기획부터 운영, 성과 분석까지 셀프애드의 전문 마케터가 도와드려요.</p>
        <div className="agency__grid">
          <div className="g"><i>🧭</i><b>전략 기획</b><span>브랜드에 맞는 맞춤형 바이럴 전략을 수립합니다</span></div>
          <div className="g"><i>🤝</i><b>인플루언서 매칭</b><span>검증된 크리에이터와 최적의 매칭을 진행합니다</span></div>
          <div className="g"><i>📊</i><b>성과 분석</b><span>데이터 기반의 성과 리포트를 제공합니다</span></div>
        </div>
        <button type="button" className="lnd-btn lnd-btn--glass" onClick={handleContactClick}>
          광고 대행 요청하기
        </button>
      </div>
    </section>
  );
}

export default AdAgencySection;
